import { firebaseClient } from "../firebaseClient";
import { postData } from "../utils/helpers";
import moment from "moment-timezone";
import * as analytics from "../utils/analytics";
import * as Sentry from "@sentry/nextjs";
import { session } from "next-auth/client";
import { getAccount, updateUser } from "../utils/sessionHelper";
import toast from "react-hot-toast";

export const initUserAnalytics = async (session, onboardPage) => {
  try {
    const db = firebaseClient.firestore();
    let origin: any = {
      onboardPage: onboardPage,
    };

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const entries = urlParams.entries();

    //@ts-ignore
    for (const entry of entries) {
      origin[entry[0]] = entry[1];
    }

    origin.fromReferral = origin.via ? "true" : "false";

    await db.collection("users").doc(session.user.uid).update({ isNeedPay: true, onboardPage: onboardPage, origin: origin });
    session.user.data.isNeedPay = true;
    session.user.data.onboardPage = onboardPage;
    session.user.data.origin = origin;

    let dataToSave = {
      ...origin,
      subStatus: "SignUp",
      twUserName: session?.user?.data?.twUserName,
      email: session?.user?.data?.email,
      followers_count: session?.user?.data?.followers_count,
      friends_count: session?.user?.data?.friends_count,
      statuses_count: session?.user?.data?.statuses_count,
    };

    await analytics.addUserProperties(dataToSave, session?.user?.data);
  }
  catch (e) {
    if (e instanceof Error) {
      console.error("Error in initUserAnalytics: " + e.message, e);
      Sentry.captureException(e);
    }
    else {
      console.error("Error in initUserAnalytics: " + e);
    }
  }
};

export const updateEmail = async (idUser, email) => {

  try {
    const db = firebaseClient.firestore();
    await db.collection("users").doc(idUser).update({ email: email });

    await postData({
      url: "user-updateDataTweetButlerDb", token: "",
      data: {
        idUser: idUser,
        data: {
          email: email,
        },
        user: { email: email },
      },
    });
  }
  catch (e) {
    console.error("Error in updateEmail: " + e.message, e);
    Sentry.captureException(e);
  }
};

export const guessTimezone = async (session) => {

  try {
    var tz = moment.tz.guess();
    // if (tz && session?.user?.firebaseToken && firebaseClient.auth().currentUser) {
    // console.log("guessTimezone: " + tz);
    if (tz && session?.user?.firebaseToken && session?.user?.data?.timezone == "America/New_York") {
      console.log("detected timezone: " + tz);
      const db = firebaseClient.firestore();
      //@ts-ignore
      await db.collection("users").doc(session?.user?.uid).update({ timezone: tz });
      session.user.data.timezone = tz;
    };
  }
  catch (e) {
    console.error("Error in guessTimezone: " + e.message, e);
    Sentry.captureException(e);
  }
};

export const addEngageAccount = async (session, value, isAuthenticated) => {

  if (value && isAuthenticated) {

    let newEngageAccounts;
    value = value.replace("@", "");
    if (getAccount(session).engageAccounts) {
      if (getAccount(session).engageAccounts.includes(value)) {
        toast.error("Account already in your list");
        return;
      }
      newEngageAccounts = getAccount(session).engageAccounts;
      newEngageAccounts.unshift(value);
    }
    else {
      newEngageAccounts = [value];
    }

    // const db = firebaseClient.firestore();
    // await db.collection("users").doc(getAccount(session).id).update({ engageAccounts: newEngageAccounts });
    // getAccount(session).engageAccounts = newEngageAccounts;
    await updateUser(session, { engageAccounts: newEngageAccounts });

    toast.success("New item successfully added");
  }
  else {
    toast.error("Error, please retry");
  }

};